import Vue from 'vue';
import Vuex from 'vuex';

import EntryProxy from '@/app/proxies/EntryProxy';

import shuffle from 'shuffle-array';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,
    modules: {
    },

    state: {
        savedEntry: { reward: null },
        sky: 'light',
        sun: 'middle',
        cards: [],
        correct: 0
    },

    getters: {
        getEntry: state => state.savedEntry,
        sky: state => state.sky,
        sun: state => state.sun,
        cards: state => state.cards,
        correct: state => state.correct,
        turn: ( state ) =>
        {
            let turn = 0;
            for( let i in state.cards )
            {
                if( state.cards[i].open )
                {
                    turn++;
                }
            }
            return turn;
        }
    },

    mutations: {
        savedEntry: ( state, payload ) =>
        {
            state.savedEntry = payload;
        },
        sky: ( state, payload ) =>
        {
            state.sky = payload;
        },
        sun: ( state, payload ) =>
        {
            state.sun = payload;
        },
        newGame: ( state, payload ) =>
        {
            let cards = [];
            for( let i = 0; i < 10; i++ )
            {
                cards.push({
                    id: i,
                    good: i < 7 ? 1 : 0,
                    open: false
                });
            }
            state.cards = shuffle( cards );
            state.correct = 0;
        },
        turnedCard: ( state, payload ) =>
        {
            for( let i in state.cards )
            {
                if( state.cards[i].id === payload.id )
                {
                    state.cards[i].open = true;
                    state.correct += state.cards[i].good;
                }
            }
        }
    },

    actions: {
        saveEntry( context, payload )
        {
            let data = payload;
            data[ 'correct' ] = context.getters.correct;

            return new EntryProxy()
                .create( data )
                .then( ( response ) =>
                {
                    context.commit( 'savedEntry', response );
                    return response;
                })
                .catch( ( error ) =>
                {
                    return Promise.reject( error );
                });
        },
        sky( context, payload )
        {
            context.commit( 'sky', payload );
        },
        sun( context, payload )
        {
            context.commit( 'sun', payload );
        },
        newGame( context, payload )
        {
            context.commit( 'newGame' );
        },
        turnedCard( context, payload )
        {
            context.commit( 'turnedCard', payload );
        }
    }
});



// WEBPACK FOOTER //
// ./src/app/store/index.js